import React, { useState, useEffect, useMemo } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { TextField, MenuItem, FormGroup } from "@mui/material";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";
import { useNavigate, useLocation } from "react-router-dom";
import DataGrid from "./DataGrid";
import { ViewModal } from "./ViewModal";
import ApiAccount from "../../../../core/api/api.account";
import ApiTransaction from "../../../../core/api/api.transaction";
import { tools } from "../../../../core/utils/tools";
import ApiHome from "../../../../core/api/api.home";
import ApiSupplier from "../../../../core/api/api.supplier";
import { NumericFormat } from "react-number-format";
import GlobalFormControl from "../../_Components/GlobalFormControl";

const ReportTransaction = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const [showModalReportTransaction, setShowModalReportTransaction] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const [fromCreatedDate, setfromCreatedDate] = useState();
  const [toCreatedDate, settoCreatedDate] = useState();
  const [fromCompletionDate, setfromCompletionDate] = useState();
  const [toCompletionDate, settoCompletionDate] = useState();
  const [listData, setListData] = useState({});

  //  تامین کنندگان و حساب های آنها
  const [supplierList, setSupplierList] = useState();
  const [supplierAccount, setSupplierAccount] = useState([]);
  const [transactionTypes, setTransactionTypes] = useState();

  //  حساب های سامانه
  const [samanehAccounts, setSamanehAccounts] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  // const watchAgencyIdSou = watch("agencyIdSou", undefined);
  // const watchAgencyIdDes = watch("agencyIdDes", undefined);
  const [isExcel, setIsExcel] = useState(false);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : getValues("pageNumber");

  useEffect(() => {
    (async () => {
      try {
        const apiData = await ApiTransaction.getAllTransactionReport({
          fromCreatedDate: searchParams.get("fromCreatedDate"),
          toCreatedDate: searchParams.get("toCreatedDate"),
          fromCompletionDate: searchParams.get("fromCompletionDate"),
          toCompletionDate: searchParams.get("toCompletionDate"),
          basketId: searchParams.get("basketId"),
          basketItemPersonId: searchParams.get("basketItemPersonId"),
          transactionType: searchParams.get("transactionType"),
          name: searchParams.get("name"),
          lastName: searchParams.get("lastName"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });

        setListData(apiData);
        setValue("totalCount", apiData.totalCount);

        // دریافت لیست آژانس ها
        // const allAgencies = await ApiAgency.getAllAgency({ PageNumber: 1, PageSize: 100 });
        // setLAgency(allAgencies.data);

        // دریافت حساب های سامانه
        const response = await ApiAccount.getAllAccountSaamaneh({ PageNumber: 1, PageSize: 100 });
        setSamanehAccounts(response);

        // دریافت لیست همه تامین کننده ها
        const types = await ApiHome.getEnums({ enumName: "TransactionType" });
        setTransactionTypes(types.data);
        // دریافت لیست همه تامین کننده ها
        const suppliersList = await ApiSupplier.getAllSuppliersName();
        setSupplierList(suppliersList);

        const formInputs = [
          { name: "fromCreatedDate", type: "datePicker" },
          { name: "toCreatedDate", type: "datePicker" },
          { name: "fromCompletionDate", type: "datePicker" },
          { name: "toCompletionDate", type: "datePicker" },
          { name: "basketId", type: "text" },
          { name: "basketItemPersonId", type: "text" },
          { name: "transactionType", type: "text" },
          { name: "name", type: "text" },
          { name: "lastName", type: "text" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => { };
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     setValue("accountIdSou", undefined);
  //     // دریافت لیست حساب ها
  //     if (watchAgencyIdSou != undefined && watchAgencyIdSou != 0) {
  //       let response = await ApiAccount.getAccountByAgencyId(watchAgencyIdSou);
  //       //console.log("response getAccountByAgencyId Sou", response);
  //       setLAccountSou(response.data);
  //     }
  //     else {
  //       setLAccountSou([]);
  //     }
  //   })();
  //   return () => { };
  // }, [watchAgencyIdSou]);

  const handleSupplierAccountChange = async (SupplierId) => {
    if (SupplierId)
      try {
        const response = await ApiAccount.getSupplierAccountsWithId({ SupplierId });
        setSupplierAccount(response);
        setValue("accountId", undefined);
      } catch (error) {
        console.log("error =>", error);
      }
    else {
      setValue("accountId", undefined);
      setSupplierAccount([])
    }
  };

  const onSubmit = async (data) => {
    if (!_.isEmpty(data.basketId) && !validateNumber(data.basketId)) return;
    if (!_.isEmpty(data.basketItemPersonId) && !validateNumberBasketItemPersonId(data.basketItemPersonId)) return;
    data.pageNumber = getValues("pageNumber");
    if (data.fromCreatedDate && typeof data.fromCreatedDate === "object") {
      data.fromCreatedDate = tools.DateFormat(data.fromCreatedDate);
    }
    if (data.toCreatedDate && typeof data.toCreatedDate === "object") {
      data.toCreatedDate = tools.DateFormat(data.toCreatedDate);
    }
    if (data.fromCompletionDate && typeof data.fromCompletionDate === "object") {
      data.fromCompletionDate = tools.DateFormat(data.fromCompletionDate);
    }
    if (data.toCompletionDate && typeof data.toCompletionDate === "object") {
      data.toCompletionDate = tools.DateFormat(data.toCompletionDate);
    }

    tools.setPageNumber(data, searchParams, setValue);
    if (isExcel) {
      await ApiTransaction.getAllTransactionReportExcel(data).then((response) => {
        const fileBlobUrl = URL.createObjectURL(new Blob([response]));
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.id = "file" + Math.floor(Math.random() * 100);
        anchor.href = fileBlobUrl;
        anchor.download = "TransactionReport.xlsx";
        document.body.appendChild(anchor);
        anchor.click();
      });
      setIsExcel(false)
    }
    const apiData = await ApiTransaction.getAllTransactionReport(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);


    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/reportTransaction?${queryString}`);
  };
  const validateNumber = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketId", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketId");
      return true;
    }
  };
  const validateNumberBasketItemPersonId = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonId", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonId");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">گزارش تراکنش های سامانه</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست تراکنش های موجود</span>
          </h3>
          <div className="card-toolbar">
            {/* <Link className="btn btn-success" variant="success"
                            key={0}
                            to={{
                                pathname: `/agencyTransaction/0`,
                                state: { id: 0 }
                            }}
                        >
                            <AddCircle className='mr-1' />
                            افزودن تراکنش
                        </Link> */}
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0 ">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link" eventKey="0">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body eventKey="0">
                      <Card.Body className="pt-0">
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive px-2 mt-5">
                            {/* https://stackoverflow.com/questions/7033420/jquery-date-picker-z-index-issue */}
                            <Controller
                              name="fromCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  placeholder=" از تاریخ ایجاد"
                                  onChange={(date) => {
                                    var toCreatedDate = getValues("toCreatedDate");
                                    onChange(date);
                                    if (
                                      !toCreatedDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCreatedDate).getTime())
                                    ) {
                                      // Set the value of toCreatedDate to the same as toCreatedDate
                                      setValue("toCreatedDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2 mt-5">
                            <Controller
                              name="toCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker value={value} onChange={onChange} placeholder="تا تاریخ ایجاد" />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2 mt-5">
                            <Controller
                              name="fromCompletionDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  placeholder=" از تاریخ موثر"
                                  onChange={(date) => {
                                    var toCompletionDate = getValues("toCompletionDate");
                                    onChange(date);
                                    if (
                                      !toCompletionDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCompletionDate).getTime())
                                    ) {
                                      // Set the value of toCompletionDate to the same as toCompletionDate
                                      setValue("toCompletionDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2 mt-5">
                            <Controller
                              name="toCompletionDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker value={value} onChange={onChange} placeholder="تا تاریخ موثر" />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="basketId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره سفارش"
                                  type="search"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumber(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketId && (
                              <div className="text-small-1 text-danger"> {errors.basketId.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="basketItemPersonId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره بلیط"
                                  size="small"
                                  type="search"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketItemPersonId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonId(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonId && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonId.message}</div>
                            )}
                          </Col>
                          {/* <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="transactionEffect"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="تاثیر تراکنش"
                                  className="mt-5"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onChange={onChange}
                                >
                                  <MenuItem key={0} value={undefined}>
                                    {" "}
                                    تمام تراکنش ها{" "}
                                  </MenuItem>
                                  <MenuItem key={1} value={"1"}>
                                    {" "}
                                    تراکنش های موثر{" "}
                                  </MenuItem>
                                  <MenuItem key={2} value={"2"}>
                                    {" "}
                                    تراکنش های غیر موثر{" "}
                                  </MenuItem>
                                </TextField>
                              )}
                            />
                          </Col> */}

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="name"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام مسافر"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی مسافر"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="supplierId"
                              control={control}
                              // rules={{ required: true, }}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="انتخاب تامین کننده"
                                  className="mt-5 "
                                  variant="outlined"
                                  margin="normal"
                                  size="small"
                                  value={value || ""}
                                  onInput={(e) => {
                                    onChange(e);
                                    handleSupplierAccountChange(e.target.value);
                                  }}
                                  onChange={(e) => {
                                    onChange(e);
                                    handleSupplierAccountChange(e.target.value);
                                  }}
                                >
                                  <MenuItem key={99} value={undefined}>
                                    {" "}
                                    --{" "}
                                  </MenuItem>
                                  {supplierList?.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>
                                      {item.companyName}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="accountId"
                              control={control}
                              // rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="حساب تامین کننده"
                                  className="mt-5 "
                                  variant="outlined"
                                  margin="normal"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                  onChange={onChange}
                                >
                                  <MenuItem key={99} value={undefined}>
                                    {" "}
                                    --{" "}
                                  </MenuItem>
                                  {supplierAccount?.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>
                                      {" "}
                                      {item.accountOwnerName + "-- " + item.bank + "-- " + item.accountNumber}{" "}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2 ">
                            <Controller
                              name="sourceAccountId"
                              control={control}
                              // rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="انتخاب حساب داخلی"
                                  className="mt-5"
                                  variant="outlined"
                                  margin="normal"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                  onChange={onChange}
                                >
                                  <MenuItem key={99} value={undefined}>
                                    {" "}
                                    --{" "}
                                  </MenuItem>
                                  {samanehAccounts?.data?.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>
                                      {" "}
                                      {item.accountOwnerName + "-- " + item.bank + "-- " + item.accountNumber}{" "}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="transactionType"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="نوع تراکنش "
                                  className="mt-5"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                  onChange={onChange}
                                //defaultValue = {4}
                                >
                                  <MenuItem key={0} value={undefined}>
                                    {" "}
                                    --{" "}
                                  </MenuItem>
                                  {transactionTypes?.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>
                                      {item.title}{" "}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive px-2 mt-3">
                            <Button
                              className=""
                              variant="success"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                tools.handleResetAdvanceSearchBox(watch, reset);
                              }}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو
                            </Button>
                            <Button
                              className="ml-4"
                              variant="info"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(true);
                              }}
                            >
                              {(isSubmitting && isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <InsertDriveFile /> فایل اکسل
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  setShowModalReportTransaction={setShowModalReportTransaction}
                  setSelectedReport={setSelectedReport}
                />
              </Col>
              {showModalReportTransaction && (
                <ViewModal
                  showModalReportTransaction={showModalReportTransaction}
                  setShowModalReportTransaction={setShowModalReportTransaction}
                  selectedReport={selectedReport}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default ReportTransaction;

{
  /* <Controller
  name="agencyIdDes"
  control={control}
  render={({ field: { onChange, value } }) => (
    <TextField
      select
      label="انتخاب آژانس مقصد"
      margin="normal"
      variant="outlined"
      size='small'
      value={value | ""}
      onChange={onChange}
    //onChange={(event) => { onChange(event); handleAgencyIdDesChange(event); }} // اضافه کردن onChange
    >
      <MenuItem key={99} value={undefined} > --  </MenuItem>
      <MenuItem key={0} value={0} > همه موارد  </MenuItem>
      {lAgency?.map((item, index) =>
        <MenuItem key={index} value={item.id} >{item.name} </MenuItem>
      )}
    </TextField>
  )}
/> */
}
